import { mapState } from 'vuex'
import mqtt from 'mqtt'

const mqtt_mixin = {
  data() {
    return {
      timeout: undefined,
      socket: null,
      topic: null,
      callback: null,
    }
  },
  computed: {
    ...mapState('auth', ['empresaAtual']),
  },
  methods: {
    connectMqtt(callback) {
      this.callback = callback
      // Conectar ao broker MQTT via WebSocket
      this.topic = `/${this.empresaAtual.public_id}`
      this.socket = mqtt.connect('wss://api.rotacertasistemas.com.br:9001', {
        clean: true,
        // protocol: 'wss',
        keepalive: 60000, // Tempo de keepalive
        rejectUnauthorized: false, // Defina como 'true' em produção para maior segurança
        connectTimeout: 30 * 1000, // ms
        reconnectPeriod: 4000, // ms
        clientId: 'emqx_vue_' + Math.random().toString(16).substring(2, 8),
        username: 'rotacerta',
        password: '60wluzp6k06pMJEZ9dpC',
      })
      window.socket = this.socket
      // Quando o cliente se conectar ao broker MQTT
      this.socket.on('connect', () => {
        console.log('Conectado ao broker MQTT')
        // Assine o tópico desejado
        this.socket.subscribe(this.topic, { tos: 0 }, (err) => {
          if (!err) {
            console.log(`Inscrito no tópico: ${this.topic}`)
          } else {
            console.error('Erro ao se inscrever:', err)
          }
        })
      })
      // Quando uma mensagem for recebida
      this.socket.on('message', (topic, message) => {
        console.debug(
          `Mensagem recebida no tópico ${topic}:`,
          message.toString()
        )
        if (this.callback) {
          this.callback(message.toString())
        }
      })
    },
    publish(data, topic) {
      let jsonString = JSON.stringify(data)
      console.log(data)
      this.socket.publish(topic, jsonString, (err) => {
        if (err) {
          console.error('Erro ao publicar a mensagem:', err)
        } else {
          console.log('Mensagem publicada no tópico ' + topic)
        }
      })
    },
    disconnectMqtt() {
      if (this.socket) {
        this.socket.end()
      }
    },
  },
  beforeDestroy() {
    this.disconnectMqtt()
  },
}
export { mqtt_mixin }
